{
  "labels": {
    "paste": "Yapıştır",
    "pasteAsPlaintext": "Düz metin olarak yapıştır",
    "pasteCharts": "Grafikleri yapıştır",
    "selectAll": "Tümünü seç",
    "multiSelect": "Seçime öge ekle",
    "moveCanvas": "Tuvali taşı",
    "cut": "Kes",
    "copy": "Kopyala",
    "copyAsPng": "Panoya PNG olarak kopyala",
    "copyAsSvg": "Panoya SVG olarak kopyala",
    "copyText": "Panoya metin olarak kopyala",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Bir öne getir",
    "sendToBack": "Arkaya gönder",
    "bringToFront": "En öne getir",
    "sendBackward": "Bir geriye gönder",
    "delete": "Sil",
    "copyStyles": "Stilleri kopyala",
    "pasteStyles": "Stilleri yapıştır",
    "stroke": "Vurgu",
    "background": "Arka plan",
    "fill": "Doldur",
    "strokeWidth": "Kontur genişliği",
    "strokeStyle": "Kontur stili",
    "strokeStyle_solid": "Dolu",
    "strokeStyle_dashed": "Kesik çizgili",
    "strokeStyle_dotted": "Noktalı",
    "sloppiness": "Üstün körülük",
    "opacity": "Opaklık",
    "textAlign": "Metin hizala",
    "edges": "Kenarlar",
    "sharp": "Keskin",
    "round": "Yuvarlak",
    "arrowheads": "Ok uçları",
    "arrowhead_none": "Yok",
    "arrowhead_arrow": "Ok",
    "arrowhead_bar": "Çizgi",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Üçgen",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Yazı tipi boyutu",
    "fontFamily": "Yazı tipi ailesi",
    "addWatermark": "\"Excalidraw ile yapıldı\" yazısını ekle",
    "handDrawn": "El-yazısı",
    "normal": "Normal",
    "code": "Kod",
    "small": "Küçük",
    "medium": "Orta",
    "large": "Büyük",
    "veryLarge": "Çok geniş",
    "solid": "Dolu",
    "hachure": "Taralı",
    "zigzag": "Zikzak",
    "crossHatch": "Çapraz-taralı",
    "thin": "İnce",
    "bold": "Kalın",
    "left": "Sol",
    "center": "Ortala",
    "right": "Sağ",
    "extraBold": "Ekstra kalın",
    "architect": "Mimar",
    "artist": "Sanatçı",
    "cartoonist": "Karikatürist",
    "fileTitle": "Dosya adı",
    "colorPicker": "Renk seçici",
    "canvasColors": "Tuvalin üzerinde kullanıldı",
    "canvasBackground": "Tuval arka planı",
    "drawingCanvas": "Çizim tuvali",
    "layers": "Katmanlar",
    "actions": "Eylemler",
    "language": "Dil",
    "liveCollaboration": "Canlı ortak çalışma alanı...",
    "duplicateSelection": "Çoğalt",
    "untitled": "Adsız",
    "name": "İsim",
    "yourName": "İsminiz",
    "madeWithExcalidraw": "Excalidraw ile yapıldı",
    "group": "Seçimi grup yap",
    "ungroup": "Seçilen grubu dağıt",
    "collaborators": "Ortaklar",
    "showGrid": "Izgarayı göster",
    "addToLibrary": "Kütüphaneye ekle",
    "removeFromLibrary": "Kütüphaneden kaldır",
    "libraryLoadingMessage": "Kütüphane yükleniyor…",
    "libraries": "Kütüphanelere gözat",
    "loadingScene": "Sahne yükleniyor…",
    "align": "Hizala",
    "alignTop": "Yukarı hizala",
    "alignBottom": "Aşağı hizala",
    "alignLeft": "Sola hizala",
    "alignRight": "Sağa hizala",
    "centerVertically": "Dikeyde ortala",
    "centerHorizontally": "Yatayda ortala",
    "distributeHorizontally": "Yatay dağıt",
    "distributeVertically": "Dikey dağıt",
    "flipHorizontal": "Yatay döndür",
    "flipVertical": "Dikey döndür",
    "viewMode": "Görünüm modu",
    "share": "Paylaş",
    "showStroke": "Kontur için renk seçiciyi göster",
    "showBackground": "Arkaplan için renk seçiciyi göster",
    "toggleTheme": "Temayı etkinleştir/devre dışı bırak",
    "personalLib": "Kişisel Kitaplık",
    "excalidrawLib": "Excalidraw Kitaplığı",
    "decreaseFontSize": "Yazı Tipi Boyutunu Küçült",
    "increaseFontSize": "Yazı Tipi Boyutunu Büyült",
    "unbindText": "Metni çöz",
    "bindText": "Metni taşıyıcıya bağla",
    "createContainerFromText": "Metni bileşen içinde sar",
    "link": {
      "edit": "Bağlantıyı düzenle",
      "editEmbed": "Bağlantıyı düzenle & yerleştir",
      "create": "Bağlantı oluştur",
      "createEmbed": "Bağlantı oluştur & yerleştir",
      "label": "Bağlantı",
      "labelEmbed": "Bağlantı & yerleştirme",
      "empty": "Herhangi bir bağlantı oluşturulmadı"
    },
    "lineEditor": {
      "edit": "Çizgiyi düzenle",
      "exit": "Çizgi düzenlemeden çık"
    },
    "elementLock": {
      "lock": "Kilitle",
      "unlock": "Kilidi Kaldır",
      "lockAll": "Hepsini kilitle",
      "unlockAll": "Hepsinin kilidini kaldır"
    },
    "statusPublished": "Yayınlandı",
    "sidebarLock": "Kenar çubuğu açık kalsın",
    "selectAllElementsInFrame": "Çerçevedeki tüm bileşenleri seç",
    "removeAllElementsFromFrame": "Çerçevedeki tüm bileşenleri sil",
    "eyeDropper": "Tuvalden renk seç",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Öğe eklenmedi...",
    "hint_emptyLibrary": "Öğelerden birini eklemek için öğeyi seçiniz veya aşağıdaki genel kütüphaneden öğeleri ekleyin.",
    "hint_emptyPrivateLibrary": "Tuvalden bir eleman seçerek sayfaya ekleyin."
  },
  "buttons": {
    "clearReset": "Tuvali sıfırla",
    "exportJSON": "Dosyaya aktar",
    "exportImage": "Resimleri dışa aktar...",
    "export": "Şuraya kaydet...",
    "copyToClipboard": "Panoya kopyala",
    "save": "Geçerli dosyaya kaydet",
    "saveAs": "Farklı kaydet",
    "load": "Aç",
    "getShareableLink": "Paylaşılabilir bağlantı al",
    "close": "Kapat",
    "selectLanguage": "Dil seçin",
    "scrollBackToContent": "İçeriğe geri dön",
    "zoomIn": "Yakınlaştır",
    "zoomOut": "Uzaklaştır",
    "resetZoom": "Yakınlaştırmayı sıfırla",
    "menu": "Menü",
    "done": "Tamam",
    "edit": "Düzenle",
    "undo": "Geri Al",
    "redo": "Yeniden yap",
    "resetLibrary": "Kütüphaneyi sıfırla",
    "createNewRoom": "Yeni oda oluştur",
    "fullScreen": "Tam ekran",
    "darkMode": "Koyu tema",
    "lightMode": "Açık tema",
    "zenMode": "Zen modu",
    "objectsSnapMode": "Nesnelere hizala",
    "exitZenMode": "Zen modundan çık",
    "cancel": "İptal",
    "clear": "Temizle",
    "remove": "Kaldır",
    "embed": "",
    "publishLibrary": "Yayınla",
    "submit": "Gönder",
    "confirm": "Onayla",
    "embeddableInteractionButton": "Etkileşime girmek için tıkla"
  },
  "alerts": {
    "clearReset": "Tuvalin tamamı temizlenecek. Emin misiniz?",
    "couldNotCreateShareableLink": "Paylaşılabilir bağlantı oluşturulamadı.",
    "couldNotCreateShareableLinkTooBig": "Paylaşılabilir bağlantı oluşturulamadı: sahne çok büyük",
    "couldNotLoadInvalidFile": "Bilinmeyen dosya yüklenemiyor",
    "importBackendFailed": "Sunucudan içe aktarma başarısız.",
    "cannotExportEmptyCanvas": "Boş tuval dışarıya aktarılamaz.",
    "couldNotCopyToClipboard": "Panoya kopyalanamıyor.",
    "decryptFailed": "Şifrelenmiş veri çözümlenemedi.",
    "uploadedSecurly": "Yükleme uçtan uca şifreleme ile korunmaktadır. Excalidraw sunucusu ve üçüncül şahıslar içeriği okuyamayacaktır.",
    "loadSceneOverridePrompt": "Harici çizimler yüklemek mevcut olan içeriği değiştirecektir. Devam etmek istiyor musunuz?",
    "collabStopOverridePrompt": "Oturumu sonlandırmak daha önceki, yerel olarak kaydedilmiş çizimin üzerine kaydedilmesine sebep olacak. Emin misiniz?\n\n(Yerel çiziminizi kaybetmemek için tarayıcı sekmesini kapatabilirsiniz.)",
    "errorAddingToLibrary": "Öğe kütüphaneye eklenemedi",
    "errorRemovingFromLibrary": "Öğe kütüphaneden silinemedi",
    "confirmAddLibrary": "Bu, kitaplığınıza {{numShapes}} tane şekil ekleyecek. Emin misiniz?",
    "imageDoesNotContainScene": "Bu görüntü herhangi bir sahne verisi içermiyor gibi görünüyor. Dışa aktarma sırasında sahne yerleştirmeyi etkinleştirdiniz mi?",
    "cannotRestoreFromImage": "Sahne bu resim dosyasından geri yüklenemedi",
    "invalidSceneUrl": "Verilen bağlantıdan çalışma alanı yüklenemedi. Dosya bozuk olabilir veya geçerli bir Excalidraw JSON verisi bulundurmuyor olabilir.",
    "resetLibrary": "Bu işlem kütüphanenizi sıfırlayacak. Emin misiniz?",
    "removeItemsFromsLibrary": "{{count}} öğe(ler) kitaplıktan kaldırılsın mı?",
    "invalidEncryptionKey": "Şifreleme anahtarı 22 karakter olmalı. Canlı işbirliği devre dışı bırakıldı.",
    "collabOfflineWarning": "İnternet bağlantısı bulunamadı. Değişiklikleriniz kaydedilmeyecek!"
  },
  "errors": {
    "unsupportedFileType": "Desteklenmeyen dosya türü.",
    "imageInsertError": "Görsel eklenemedi. Daha sonra tekrar deneyin...",
    "fileTooBig": "Dosya çok büyük. İzin verilen maksimum boyut {{maxSize}}.",
    "svgImageInsertError": "SVG resmi eklenemedi. SVG işaretlemesi geçersiz görünüyor.",
    "failedToFetchImage": "",
    "invalidSVGString": "Geçersiz SVG.",
    "cannotResolveCollabServer": "İş birliği sunucusuna bağlanılamıyor. Lütfen sayfayı yenileyip tekrar deneyin.",
    "importLibraryError": "Kütüphane yüklenemedi",
    "collabSaveFailed": "Backend veritabanına kaydedilemedi. Eğer problem devam ederse, çalışmanızı korumak için dosyayı yerel olarak kaydetmelisiniz.",
    "collabSaveFailed_sizeExceeded": "Backend veritabanına kaydedilemedi; tuval çok büyük. Çalışmanızı korumak için dosyayı yerel olarak kaydetmelisiniz.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": "Resimleri kütüphaneye ekleme desteği yakında geliyor!"
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Seçme",
    "image": "Görsel ekle",
    "rectangle": "Dikdörtgen",
    "diamond": "Elmas",
    "ellipse": "Elips",
    "arrow": "Ok",
    "line": "Çizgi",
    "freedraw": "Çiz",
    "text": "Yazı",
    "library": "Kütüphane",
    "lock": "Seçilen aracı çizimden sonra aktif tut",
    "penMode": "Kalem modu - dokunmayı engelle",
    "link": "Seçilen şekil için bağlantı Ekle/Güncelle",
    "eraser": "Silgi",
    "frame": "Çerçeve aracı",
    "magicframe": "",
    "embeddable": "Web Yerleştirme",
    "laser": "Lazer işaretçisi",
    "hand": "",
    "extraTools": "Daha fazla araç",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Tuval eylemleri",
    "selectedShapeActions": "Seçilen şekil aksiyonları",
    "shapes": "Şekiller"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "Birden fazla nokta için tıklayın, tek çizgi için sürükleyin",
    "freeDraw": "Tıkla ve sürükle, bitirdiğinde serbest bırak",
    "text": "İpucu: seçme aracıyla herhangi bir yere çift tıklayarak da yazı ekleyebilirsin",
    "embeddable": "Web sitesi yerleştirmek için sürükle bırak",
    "text_selected": "Metni düzenlemek için çift tıklayın veya ENTER'a basın",
    "text_editing": "Düzenlemeyi bitirmek için ESC veya Ctrl/Cmd+ENTER tuşlarına basın",
    "linearElementMulti": "Bitirmek için son noktaya tıklayın ya da Escape veya Enter tuşuna basın",
    "lockAngle": "SHIFT tuşuna basılı tutarak açıyı koruyabilirsiniz",
    "resize": "Yeniden boyutlandırırken SHIFT tuşunu basılı tutarak oranları sınırlayabilirsiniz,\nmerkezden yeniden boyutlandırmak için ALT tuşunu basılı tutun",
    "resizeImage": "SHIFT'e basılı tutarak serbestçe yeniden boyutlandırabilirsiniz, merkezden yeniden boyutlandırmak için ALT tuşunu basılı tutun",
    "rotate": "Döndürürken SHIFT tuşuna basılı tutarak açıları koruyabilirsiniz",
    "lineEditor_info": "Puanları düzenlemek için ctrl veya cmd tuşuna basılı tutup çift tıklayın veya enter tuşuna basın",
    "lineEditor_pointSelected": "Sil tuşuna basarak noktaları silin,\nCtrl/Cmd + D ile çoğaltın, ya da sürükleyerek taşıyın",
    "lineEditor_nothingSelected": "Düzenlemek için bir nokta seçin (birden fazla seçmek için SHIFT tuşunu basılı tutun),\nveya Alt tuşunu basılı tutun ve yeni noktalar eklemek için tıklayın",
    "placeImage": "Resmi yerleştirmek için tıklayın ya da boyutunu manuel olarak ayarlamak için tıklayıp sürükleyin",
    "publishLibrary": "Kendi kitaplığınızı yayınlayın",
    "bindTextToElement": "Enter tuşuna basarak metin ekleyin",
    "deepBoxSelect": "Ctrl/Cmd tuşuna basılı tutarak derin seçim yapın ya da sürüklemeyi engelleyin",
    "eraserRevert": "Alt tuşuna basılı tutarak silinme için işaretlenmiş ögeleri tersine çevirin",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Önizleme gösterilemiyor",
    "canvasTooBig": "Kanvas çok büyük olabilir.",
    "canvasTooBigTip": "İpucu: En uzaktaki elemanları birbirine yakınlaştırmayı deneyin."
  },
  "errorSplash": {
    "headingMain": "Hata oluştu. Lütfen <button>sayfayı yenilemeyi deneyin.</button>",
    "clearCanvasMessage": "Yenileme sonrası sorun devam ediyorsa, lütfen <button>çizim alanını temizlemeyi deneyin.</button>",
    "clearCanvasCaveat": " Bu, yaptığınız değişiklikleri sıfırlayacak ",
    "trackedToSentry": "Tanımlayıcı ile ilgili hata {{eventId}} sistemimize yakalandı.",
    "openIssueMessage": "Sahne bilginizi hata mesajına yansıtmamak için oldukça dikkatli davrandık. Eğer sahneniz gizli değilse hatayı lütfen şuradan takip edin <button>hata takibi.</button> Lütfen aşağıya GitHub sorununa kopyalayarak ve yapıştırarak bilgi ekleyin.",
    "sceneContent": "Sahne içeriği:"
  },
  "roomDialog": {
    "desc_intro": "Çalışma alanınıza, sizinle birlikte çalışabilmeleri için başkalarını da ekleyebilirsiniz.",
    "desc_privacy": "Çalışma ortamında yaptıklarınız ve çizimleriniz uçtan uca şifrelemeyle saklanmaktadır. Sunucularımız dahi bu verileri şifrelenmemiş haliyle göremez.",
    "button_startSession": "Oturumu başlat",
    "button_stopSession": "Oturumu sonlandır",
    "desc_inProgressIntro": "Ortak çalışma ortamı oluşturuldu.",
    "desc_shareLink": "Bu bağlantıyı birlikte çalışacağınız kişilerle paylaşabilirsiniz:",
    "desc_exitSession": "Çalışma ortamını kapattığınızda ortak çalışmadan ayrılmış olursunuz ancak kendi versiyonunuzda çalışmaya devam edebilirsiniz. Bu durumda ortak çalıştığınız diğer kişiler etkilenmeyecek, çalışma ortamındaki versiyon üzerinden çalışmaya devam edebilecekler.",
    "shareTitle": "Excalidraw'da canlı ortak calışma oturumuna katıl"
  },
  "errorDialog": {
    "title": "Hata"
  },
  "exportDialog": {
    "disk_title": "Belleğe kaydet",
    "disk_details": "Sahne verilerini daha sonra içe aktarabileceğiniz bir dosyaya aktarın.",
    "disk_button": "Dosyaya kaydet",
    "link_title": "Paylaşılabilir bağlantı",
    "link_details": "Salt okunur bir bağlantı olarak dışa aktarın.",
    "link_button": "Bağlantı olarak dışa aktar",
    "excalidrawplus_description": "Sahneyi Excalidraw+ çalışma alanınıza kaydedin.",
    "excalidrawplus_button": "Dışa aktar",
    "excalidrawplus_exportError": "Şu anda Excalidraw+'a aktarılamadı..."
  },
  "helpDialog": {
    "blog": "Blog'umuzu okuyun",
    "click": "tıkla",
    "deepSelect": "Derin seçim",
    "deepBoxSelect": "Kutu içerisinde derin seçim yapın, sürüklemeyi engelleyin",
    "curvedArrow": "Eğri ok",
    "curvedLine": "Eğri çizgi",
    "documentation": "Dokümantasyon",
    "doubleClick": "çift-tıklama",
    "drag": "sürükle",
    "editor": "Düzenleyici",
    "editLineArrowPoints": "Çizgi/ok noktalarını düzenle",
    "editText": "Etiket / metin düzenle",
    "github": "Bir hata mı buldun? Bildir",
    "howto": "Rehberlerimizi takip edin",
    "or": "veya",
    "preventBinding": "Ok bağlamayı önleyin",
    "tools": "Araçlar",
    "shortcuts": "Klavye kısayolları",
    "textFinish": "Düzenlemeyi bitir (metin düzenleyici)",
    "textNewLine": "Yeni satır ekle (metin düzenleyici)",
    "title": "Yardım",
    "view": "Görünüm",
    "zoomToFit": "Tüm öğeleri sığdırmak için yakınlaştır",
    "zoomToSelection": "Seçime yakınlaş",
    "toggleElementLock": "Seçimi Kilitle/çöz",
    "movePageUpDown": "Sayfayı yukarı/aşağı kaydır",
    "movePageLeftRight": "Sayfayı sola/sağa kaydır"
  },
  "clearCanvasDialog": {
    "title": "Tuvali temizle"
  },
  "publishDialog": {
    "title": "Kitaplığı yayınla",
    "itemName": "Öğe adı",
    "authorName": "Yazar adı",
    "githubUsername": "GıtHub kullanıcı adı",
    "twitterUsername": "Twitter kullanıcı adı",
    "libraryName": "Kitaplık adı",
    "libraryDesc": "Kitaplık açıklaması",
    "website": "Web sitesi",
    "placeholder": {
      "authorName": "Adınız ya da kullanıcı adınız",
      "libraryName": "Kitaplığınızın adı",
      "libraryDesc": "İnsanların kullanımını anlamasına yardımcı olmak için kitaplığınızın açıklaması",
      "githubHandle": "Github bağlantısı ( tercihe bağlı), kütüphane gözden geçirme için onaylandığında düzenleyebiliesiniz diye",
      "twitterHandle": "Twitter kullanıcı adı ( tercihe bağlı), bu sayede Twitter üzerinde paylaşıren çalışmanızı size atfedebiliriz",
      "website": "Kişisel web sayfanızı ya da başka bir yeri bağlayın (tercihe bağlı)"
    },
    "errors": {
      "required": "Gerekli",
      "website": "Geçerli bir URL girin"
    },
    "noteDescription": "Submit your library to be included in the <link>genel kütüphane reposu</link>diğer insanlar çizimlerinde kullanabilsin diye.",
    "noteGuidelines": "Önce kütüphane elle onaylanmalı. şunu okuyun <link>yönergeler</link> onaylamadan önce. gerekli olması halinde iletişim kurmak için ve değişiklik için Github hesabı gerekli, ama çok da illaki olmalı değil.",
    "noteLicense": "Bunu onaylayarak, kütüğhanenin şu lisansla yayınlanmasını onaylıyorsunuz <link>MIT Lisans, </link>ki bu kısaca herkesin onu kısıtlama olmaksızın kullanabileceği anlamına gelmektedir.",
    "noteItems": "Her kütüphane kendi ismine sahip olmalı ki tarama yapabilelim. Şu kütüphane ögeleri dahil edilecek:",
    "atleastOneLibItem": "Lütfen başlamak için en az bir tane kütüphane ögesi seçin",
    "republishWarning": "Not: seçilen ögelerden bir kısmı zaten yayınlanmış/gönderilmiş. Yalnızca mevcut kütüphane ve gönderileri güncellerken yeniden gönderme işlemi yapmalısınız."
  },
  "publishSuccessDialog": {
    "title": "Kütüphane gönderildi",
    "content": "Teşekkürler {{authorName}}. Kütüphaneniz gözden geçirme için alındı. Durumu takip edebilirsiniz<link>burada</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Kütüphaneyi sıfırla",
    "removeItemsFromLib": "Seçilen ögeleri kütüphaneden kaldır"
  },
  "imageExportDialog": {
    "header": "Resmi dışa aktar",
    "label": {
      "withBackground": "Arka plan",
      "onlySelected": "Sadece seçilen",
      "darkMode": "Karanlık mod",
      "embedScene": "Sahne yerleştir",
      "scale": "Ölçeklendir",
      "padding": "Dış boşluk"
    },
    "tooltip": {
      "embedScene": "Sahne verisi, sahnenin geri yüklenebilmesi için dışarı aktarılan PNG/SVG dosyasına kaydedilecektir. Bu, dışa aktarılan dosya boyutunu arttıracaktır."
    },
    "title": {
      "exportToPng": "PNG olarak dışa aktar",
      "exportToSvg": "SVG olarak dışa aktar",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Panoya kopyala"
    }
  },
  "encrypted": {
    "tooltip": "Çizimleriniz uçtan-uca şifrelenmiştir, Excalidraw'ın sunucuları bile onları göremez.",
    "link": "Excalidraw'da uçtan uca şifreleme hakkında blog yazısı"
  },
  "stats": {
    "angle": "Açı",
    "element": "Bileşen",
    "elements": "Bileşenler",
    "height": "Yükseklik",
    "scene": "Sahne",
    "selected": "Seçili",
    "storage": "Depolama",
    "title": "İnekler için istatistikler",
    "total": "Toplam",
    "version": "Sürüm",
    "versionCopy": "Kopyalamak için tıkla",
    "versionNotAvailable": "Sürüm mevcut değil",
    "width": "Genişlik"
  },
  "toast": {
    "addedToLibrary": "Kütüphaneye eklendi",
    "copyStyles": "Stiller kopyalandı.",
    "copyToClipboard": "Panoya kopyalandı.",
    "copyToClipboardAsPng": "{{exportSelection}} panoya PNG olarak\n({{exportColorScheme}}) kopyalandı",
    "fileSaved": "Dosya kaydedildi.",
    "fileSavedToFilename": "{filename} kaydedildi",
    "canvas": "tuval",
    "selection": "seçim",
    "pasteAsSingleElement": "Tekil obje olarak yapıştırmak için veya var olan bir metin editörüne yapıştırmak için {{shortcut}} kullanın",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Şeffaf",
    "black": "Siyah",
    "white": "Beyaz",
    "red": "Kırmızı",
    "pink": "Pembe",
    "grape": "Koyu Mor",
    "violet": "Menekşe rengi",
    "gray": "Gri",
    "blue": "Mavi",
    "cyan": "Camgöbeği",
    "teal": "Deniz mavisi",
    "green": "Yeşil",
    "yellow": "Sarı",
    "orange": "Turuncu",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "Ecalidraw+'a mı gitmek istediniz?",
      "menuHint": "Dışa aktar, seçenekler, diller, ..."
    },
    "defaults": {
      "menuHint": "Dışa aktar, seçenekler, ve daha fazlası...",
      "center_heading": "",
      "toolbarHint": "Bir araç seçin ve çizime başlayın!",
      "helpHint": "Kısayollar & yardım"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "En çok kullanılan özel renkler",
    "colors": "Renkler",
    "shades": "",
    "hexCode": "Hex kodu",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "Diske Kaydet",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
